module.exports = "/images/vendor/jquery-ui-dist/ui-icons_555555_256x240.png?00dd0ec0a16a1085e714c7906ff8fb06";